<template>
    <div>
        <label class="text-lg text-gray-700 font-poppins font-bold">
            {{
                label === 'How many vehicles do you need cover for?' && directToFlowUser
                    ? 'How many vehicles do you need breakdown cover for?'
                    : label
            }}
        </label>
        <fieldset class="mt-6">
            <input
                type="text"
                v-model="localValue"
                :name="name"
                class="hidden"
            />
            <legend id="radiogroup-label" class="sr-only">
                {{ label }}
            </legend>

            <ul
                role="radiogroup"
                aria-labelledby="radiogroup-label"
                :class="{
                    'grid grid-cols-2 md:block gap-4': optionItems.length > 4 && !flowIconVersion
                }"
            >
                <li
                    v-for="(option, key) in optionItems"
                    tabindex="-1"
                    role="radio"
                    aria-checked="false"
                    @click="select(option)"
                    :key="key"
                    :data-testid="name + '__' + option.value"
                    class="group relative bg-white rounded-lg shadow-o cursor-pointer focus:outline-none hover:bg-gray-100 focus:ring-1 focus:ring-cyan mx-auto lg:w-8/12 md:w-8/12 "
                    :class="{
                        'focus:ring-offset-2': !flowIconVersion,
                        'md:mt-4': key,
                        'mt-4': key && !mobileGrid,
                        'w-11/12': !flowIconVersion && name !== 'cover_type',
                        'md:w-8/12 md:mt-4 w-full': flowIconVersion && name === 'cover_type' && option.label !== 'Vehicle Cover'
                    }"
                >
                    <div
                        class="rounded-lg px-6 py-4 sm:flex sm:justify-between text-center"
                        :class="{
                            'customerPadding': name === 'cover_type' || flowIconVersion,
                            'buttonHeight': name !== 'cover_type' && flowIconVersion,
                            'mb-4': optionItems.length > 4 && flowIconVersion && name === 'vehicle' && option.label !== 'Over ten' && option.label !== 'Six or more'
                        }"
                    >
                        <div
                            class="flex items-center w-full"
                            :class="{
                                // 'xxsViewport gap-3': name === 'cover_type',
                                // 'gap-3': flowIconVersion,
                                'titleHeight': isAddOn && flowIconVersion,
                            }"
                        >
                            <div
                                class="relative"
                                :class="{
                                    'flex items-center w-7 justify-center': flowIconVersion && isAddOn,
                                }">

                                <img v-if="name === 'cover_type' && !flowIconVersion" :src="getImageSrc(option.svg)" :class="{'svg': name === 'cover_type'}" class="block opacity-75 h-6 w-6 max-w-none" />
                                <img
                                    v-if="flowIconVersion"
                                    :src="getImageSrc(option.svg)"
                                    class="block opacity-75"
                                    :class="{
                                        'svg': name === 'cover_type',
                                        'w-7 h-7': name === 'people_form',
                                        'w-6 h-6': name === 'vehicle',
                                        'w-8 h-8': option.svg === 'nationwide-xl',
                                        'w-5 h-5': option.svg === 'cross-black'
                                    }"
                                />
                                <div
                                    v-if="flowIconVersion && name === 'vehicle'"
                                    class="absolute bottom-0 right-0 transform translate-x-1/4 translate-y-1/4 w-5 h-5 rounded-full bg-white border border-white flex items-center justify-center text-xs font-bold text-black hover:bg-gray-100"
                                >
                                    <span>
                                        {{
                                            option.value === 'showFullOptions' ? '6+' :
                                            option.value === 'showFamilyOptions' ? '2+' :
                                            option.label === 'Four or more' ? '4+' :
                                            option.label === 'Over ten' ? '10+' :
                                            option.value
                                        }}
                                    </span>
                                </div>
                            </div>

                            <div
                                class="text-md w-full"
                                :class="{
                                    'text-left': name == 'cover_type' || name === 'people_form',
                                    'text-left pl-3': flowIconVersion,
                                }">
                                <p
                                    class=" text-gray-900 gap-2 items-center justify-between"
                                    :class="{
                                        'font-medium': isSelected(option),
                                        'font-normal': !isSelected(option),
                                        'flex': name == 'cover_type',
                                        'title': flowIconVersion || name === 'cover_type',
                                        'gap-1 sm:gap-2': !flowIconVersion,
                                        'ml-1.5': name === 'nationwide' && option.label === 'No thanks' && flowIconVersion
                                    }"
                                >

                                    <!-- Remove v-if - if we don't use new SVG flow and remove <span> with ******* (commented out) -->
                                    <!-- index.js - change vehicle labels back to "One Vehicle, Two Vehicles....." -->
                                    <span
                                        class="text-left"
                                        v-if="name !== 'vehicle'"
                                        v-html="option.label"
                                        :dusk="option.dusk"
                                    ></span>

                                    <span
                                        v-if="option.label === 'Vehicle Cover'"
                                        class="px-2 font-bold rounded-md inline-block uppercase py-1 sm:py-1 text-xxs mostPopular hidden"
                                        style="background-color: rgba(239, 68, 68, 0.9); color: white;"

                                    >
                                        Most Popular
                                    </span>
                                </p>
                                <p v-if="name == 'cover_type'" class="subtitle text-xs text-left" v-html="option.subtitle"></p>

                                <span v-if="name == 'vehicle'" :dusk="option.dusk">
                                    {{ option.label }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="absolute inset-0 rounded-lg border-2 pointer-events-none"
                        :class="{
                            'border-cyan font-medium': isSelected(option),
                            'border-transparent font-normal': !isSelected(option),
                        }"
                        aria-hidden="true"
                    ></div>
                </li>
            </ul>

            <div v-if="showFamilyDropdown && name == 'people_form'" class="my-6">
                <label class="text-lg text-gray-700 font-poppins font-bold">
                How many people in your household, including yourself, need cover?
                </label>
                <ul role="radiogroup" class="mt-4">
                    <li
                        v-for="(option, key) in fullOptions"
                        :key="key"
                        @click="select(option)"
                        class="group relative bg-white rounded-lg shadow-o cursor-pointer focus:outline-none hover:bg-gray-100 focus:ring-1 focus:ring-cyan mx-auto lg:w-8/12 md:w-8/12 sm:w-11/12 my-4"
                        :class="{
                            'w-full': flowIconVersion,
                            'focus:ring-offset-2': !flowIconVersion
                        }"
                    >
                        <div
                            class="rounded-lg px-6 py-4 flex sm:justify-between text-center"
                            :class="{
                                'p-2 text-left customerPadding': flowIconVersion,
                            }"
                        >
                            <div
                                v-if="name === 'people_form' && flowIconVersion"
                                class="relative items-center"
                                :class="{
                                    'flex': isAddOn,
                                    'w-7 h-7 mr-4 text-left': flowIconVersion
                                }"
                            >
                              <img
                                  src="/img/icons/svg/onePerson.svg"
                                  class="block opacity-75 h-7 w-7"
                              />
<!--                                <img :src="getImageSrc(option.svg)" class="block opacity-75 h-6 w-6" />-->
                                <div class="absolute bottom-0 right-0 transform translate-x-1/4 translate-y-1/4 flex items-center justify-center w-5 h-5 rounded-full bg-white border border-white hover:bg-gray-100 text-black text-xs font-bold">
                                    <span>{{ option.value }}</span>
                                </div>
                            </div>
                            <div
                                class="flex items-center w-full"
                                :class="{
                                    'text-left' : name == 'people_form' && flowIconVersion
                                }">
                                <div class="text-md w-full">
                                    <p
                                        class="text-gray-900"
                                        :class="{
                                            'font-medium': isSelected(option),
                                            'font-normal': !isSelected(option),
                                        }"
                                    >
                                        <span v-html="option.label" :dusk="option.dusk"></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            class="absolute inset-0 rounded-lg border-2 pointer-events-none"
                            aria-hidden="true"
                            :class="{
                                'border-cyan': isSelected(option),
                                'border-transparent': !isSelected(option),
                            }"
                        ></div>
                    </li>
                </ul>
            </div>

        </fieldset>

        <div v-if="flowIconVersion" class="flex items-center bg-gray-50 justify-center mt-8">
            <div class="text-xxs sm:text-sm font-base text-gray-700 font-poppins px-3 py-4 sm:p-4 sm:py-6">
                <span class="flex items-center">
                    <svg width="24" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-3 sm:mr-2">
                        <g transform="translate(-16 0.005)">
                            <path
                                d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                                class="shield-check-a"
                            />
                            <path
                                d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                                class="shield-check-b"
                                transform="translate(-75.994 -127.76)"
                            />
                        </g>
                    </svg>
                    <span class="text-sm">
                        {{
                            name === 'nationwide' ? "Our average arrival time is only 43 minutes"
                            : name === 'home' && hidePersonalFlow ? "The UK's best-rated cover - giving you total peace of mind"
                            : name === 'home' && !hidePersonalFlow ? "24/7 UK based call centre, answers in 40 seconds"
                            : name === 'cover_type' ? "The UK's best-rated cover - giving you total peace of mind"
                            : name === 'people_form' ?  "Cover for you and your members when driving any vehicle"
                            : "We cover vehicles, whoever's driving"
                        }}
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "RadioGroup",
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(localValue) {
                this.$emit('input', localValue)
            }
        },
        mobileGrid() {
            return this.options.length > 4
        }
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number, Array],
            default: null
        },
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: ''
        },
        fullOptions: {
            type: Array,
            default: () => []
        },
        // Change to true for SVG flow
        flowIconVersion: {
            type: Boolean,
            default: false
        },
        directToFlowUser: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showFullOptions: false,
            showFamilyDropdown: false,
            optionItems: null,
            // flowIconVersion
            isAddOn: this.name === 'home' || this.name === 'nationwide' || this.name === 'people_form',
            hidePersonalFlow: window.hidePersonalPackageFlow
        }
    },
    methods: {
        getImageSrc(iconName) {
			return `/img/icons/svg/${iconName}.svg`;
		},
        isSelected(option) {
            return option.value === this.localValue
        },
        selectFamilyDropdown(e) {
            console.log("e target", e.target.value, typeof e.target.value)

            this.localValue = Number(e.target.value)
            this.$emit('select-family-dropdow', this.localValue)
        },
        select(option) {
            this.showFullOptions = false
            this.showFamilyDropdown = false

            /*if (option.value === 'showFamilyOptions') {
                this.showFamilyDropdown = true
                
                // If family option is selected, update flow_step to family_option_q
                this.apiUpdateCurrentSplitTestStep('family_option_q')
                
                return
            }*/

            if (option.value === 'showFullOptions') {
                this.optionItems = this.fullOptions
                this.showFullOptions = true
                return
            }
            this.localValue = option.value

            // If user selects a option from nationwide, update flow_step to capture_form
            if (this.name === 'nationwide') {
                this.apiUpdateCurrentSplitTestStep('capture_form')
            }
        },
    },
    created() {
        this.optionItems = this.options
    },
    watch: {
        options: {
            handler(newOptions) {
                this.optionItems = newOptions;
            },
            deep: true,
        },
    },
}
</script>

<style scoped>
.titleHeight {
    height: 24px;
}
@media screen and (max-width: 400px) {
    .customerPadding {
        padding-left: 1rem;
        padding-right: 1rem;
    }
}
@media screen and (max-width: 382px) {
    .title {
        font-size: 16px;
    }
    .subtitle {
        font-size: 11px;
    }
    .mostPopular {
        font-size: 8px;
    }
}
@media screen and (max-width: 359px) {
    .svg {
        display: none
    }
    .xxsViewport {
        gap: 0;
    }
}
@media screen and (max-width: 356px) {
    .customerPadding {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
    }
}
@media screen and (max-width: 349px) {
    .svg {
        display: none
    }
}


</style>
